import React from 'react';
import styled from 'styled-components/macro';
import { CheckboxInput } from 'lib/components';
import { useTranslation } from 'react-i18next';

const PublishItemContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 12px 16px;
  gap: 16px;
  width: 100%
  height: 84px;
  background: ${({ theme }) => theme.colors.white[100]};
  border: 1px solid ${({ theme }) => theme.colors.neutral[10]};
  border-radius: 5px;
`;

type FlexRowContainerProps = {
  justifyContent?: string;
};
const FlexRowContainer = styled.div<FlexRowContainerProps>`
  display: flex;
  flex-direction: row;
  justify-content: ${props => props.justifyContent || 'center'};
  align-items: center;
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 0 12px 0 19px;
`;

const PublishTextContainer = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.neutral[100]};
`;

const PublishingPlaceTextContainer = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.neutral[80]};
`;

const PrivatePublishing = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.danger[100]};
`;

type Props = {
  itemKey: string;
  isChecked: boolean;
  onChange: () => void;
  icon: any;
  publishText: string;
  publishPlace: string;
  privatePublishing?: boolean;
  social: string;
};

export const PublishItem = ({
  itemKey,
  isChecked,
  onChange,
  icon,
  publishText,
  publishPlace,
  privatePublishing = false,
  social,
}: Props) => {
  const { t } = useTranslation();
  const isLinkedin = social === 'LinkedIn';
  return (
    <PublishItemContainer key={itemKey}>
      <FlexRowContainer>
        <CheckboxInput
          checked={isChecked}
          onChange={onChange}
          disabled={isLinkedin ? false : !publishPlace}
        />
        <IconWrapper>{icon}</IconWrapper>
        <PublishTextContainer>{publishText}</PublishTextContainer>
      </FlexRowContainer>
      {publishPlace && (
        <>
          <PublishingPlaceTextContainer>
            {t('Publishing on')} <b>{publishPlace}</b>
          </PublishingPlaceTextContainer>
          {privatePublishing && (
            <PrivatePublishing>
              {t(
                '{{social}} does not allow private publishing. The post will be visible to all.',
                { social }
              )}
            </PrivatePublishing>
          )}
        </>
      )}
      {!publishPlace && !isLinkedin && (
        <PrivatePublishing>
          {t('Please connect page or channel to your account.')}
        </PrivatePublishing>
      )}
    </PublishItemContainer>
  );
};
